import { createImageResource, deleteImageResource, getAllImageResources } from "../api";
import {
	IMAGE_RESOURCES_REDUCER_CREATE,
	IMAGE_RESOURCES_REDUCER_DELETE,
	IMAGE_RESOURCES_REDUCER_GET,
} from "../common/constants";
import ToastPopup from "../common/ToastPopup";

const getAllImageResourcesFromApi = async () => {
	try {
		const imageRes = await getAllImageResources();
		if (imageRes?.success) {
			return imageRes?.results ?? [];
		} else {
			ToastPopup(
				"error",
				imageRes?.message + (imageRes?.errors ? ". " + Object.values(imageRes?.errors) : "")
			);
			return null;
		}
	} catch (err) {
		console.log(err);
		ToastPopup("error", "Data request error: " + err);
		return null;
	}
};

const uploadImageResourceFromApi = async (data) => {
	const response = await createImageResource(data);
	if (response?.success) {
		return response?.results ?? {};
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

const deleteImageResourceFromApi = async (id) => {
	const response = await deleteImageResource(id);
	if (response?.success) {
		return response?.results ?? {};
	} else {
		ToastPopup(
			"error",
			response?.message + (response?.errors ? ". " + Object.values(response?.errors) : "")
		);
		return null;
	}
};

export const ImageResourcesReducer = (state, action) => {
	console.log("image resource reducer: ", state, action);
	switch (action.type) {
		case IMAGE_RESOURCES_REDUCER_GET:
			if (action.loading) {
				getAllImageResourcesFromApi().then((res) =>
					action.dispatch({
						...action,
						loading: false,
						data: res,
					})
				);
				return state;
			} else {
				action?.loadingCb();
				if (action?.data) {
					action?.successCb();
					return action?.data;
				} else {
					action?.failedCb();
					return state;
				}
			}

		case IMAGE_RESOURCES_REDUCER_CREATE:
			if (action?.loading) {
				uploadImageResourceFromApi(action.data).then((res) =>
					action.dispatch({ ...action, loading: false, data: res })
				);
				return state;
			} else {
				action?.loadingCb();
				if (action?.data) {
					action?.successCb();
					return [...state, action?.data];
				} else {
					action?.failedCb();
					return state;
				}
			}

		case IMAGE_RESOURCES_REDUCER_DELETE:
			if (action?.loading) {
				deleteImageResourceFromApi(action.id).then((res) =>
					action.dispatch({ ...action, loading: false, data: res })
				);
				return state;
			} else {
				action?.loadingCb();
				if (action?.data) {
					action?.successCb();
					return [...state, action?.data];
				} else {
					action?.failedCb();
					return state;
				}
			}

		default:
			break;
	}
};
